// Native <select> with label. Pass options as `{value, label}` so display
// strings stay decoupled from persisted enum values.

export interface SelectOption<T extends string = string> {
  value: T;
  label: string;
}

interface SelectFieldProps<T extends string> {
  label: string;
  value: T;
  onChange: (v: T) => void;
  options: SelectOption<T>[];
  hint?: string;
  disabled?: boolean;
  required?: boolean;
}

export function SelectField<T extends string>({
  label,
  value,
  onChange,
  options,
  hint,
  disabled,
  required,
}: SelectFieldProps<T>) {
  return (
    <label className="flex flex-col gap-1">
      <span className="text-[11px] font-medium uppercase tracking-wide text-[color:var(--bo-mute)]">
        {label}
        {required ? <span className="ms-0.5 text-[#9f1239]">*</span> : null}
      </span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as T)}
        disabled={disabled}
        className="h-10 w-full rounded-md border border-[color:var(--bo-line)] bg-white px-3 text-[13px] text-[color:var(--bo-ink)] focus:border-[color:var(--bo-mute)] focus:outline-none disabled:cursor-not-allowed disabled:bg-[color:var(--bo-bg)]"
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {hint ? <span className="text-[11px] text-[color:var(--bo-mute)]">{hint}</span> : null}
    </label>
  );
}
